import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

const countriesRegionsTreemap: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/locations-treemap`),
};

export default countriesRegionsTreemap;
